import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./AppShell";
import { MatchupsScreen } from "../screens/MatchupsScreen";
import { MatchupDetailScreen } from "../screens/MatchupDetailScreen";
import { FixturesScreen } from "../screens/FixturesScreen";
import { TableScreen } from "../screens/TableScreen";
import { SettingsScreen } from "../screens/SettingsScreen";

export const AppRoutes = () => (
	<Routes>
		<Route element={<AppShell />}>
			<Route index element={<Navigate to="/matchups" replace />} />
			<Route path="matchups" element={<MatchupsScreen />} />
			<Route path="matchups/:id" element={<MatchupDetailScreen />} />
			<Route path="fixtures" element={<FixturesScreen />} />
			<Route path="table" element={<TableScreen />} />
			<Route path="settings" element={<SettingsScreen />} />
			<Route path="*" element={<Navigate to="/matchups" replace />} />
		</Route>
	</Routes>
);
